import { apply } from '@/server/builder';

export const method = 'get';

export default (schema, request) => {
    const showArchived = request.queryParams.archive === 'true';
    const measures = schema.measures.all().models;

    const archivedFilter = ({ archivedAt }) => {
        return showArchived
            ? true
            : archivedAt === null;
    };

    return apply(measures, request.queryParams, archivedFilter);
};
